module.exports = __webpack_public_path__ + "static/media/06.4639b959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/06.jpg
// module id = 465
// module chunks = 0